"use strict";
/**
 * @fileoverview Request body type for deletion operations
 * This is a common type used across different resources
 */
Object.defineProperty(exports, "__esModule", { value: true });
